import { getStoreCoupons, getCouponInfo, getMemberCoupons, getMemberCouponInfo, claimCoupon } from '@/services/api.service';
import storeCouponModel from '@/models/storeCoupon.model';
import memberCouponModel from '@/models/memberCoupon.model';

export default {
    namespaced: true,
    state: {
        // TODO: 當有優惠卷時，將優惠卷資料存入此處
        storeCouponsResponse: {},
        storeCouponsPage: "0",
        storeCouponInfo: {},
        memberCouponsResponse: {},
        memberCouponInfo: {}
    },
    getters: {
        // 商店優惠卷 data
        storeCouponsData(state) {
            return {
                page: state.storeCouponsPage,
                size: "10"
            }
        },
        // 商店優惠卷列表
        storeCouponList(state) {
            if (!state.storeCouponsResponse || !state.storeCouponsResponse.store_coupons_list) return [];
            const ls = []
            state.storeCouponsResponse.store_coupons_list.forEach((item) => {
                ls.push(new storeCouponModel(item));
            });
            return ls
        },
        // 商店優惠卷數量
        storeCouponCount(state) {
            return state.storeCouponsResponse?.store_coupons_count || 0;
        },
        // 會員優惠卷列表
        memberCouponList(state) {
            if (!state.memberCouponsResponse || !state.memberCouponsResponse.store_member_coupons_list) return [];
            const ls = []
            state.memberCouponsResponse.store_member_coupons_list.forEach((item) => {
                ls.push(new memberCouponModel(item));
            });
            return ls
        },
        // 會員優惠卷數量
        memberCouponCount(state) {
            return state.memberCouponsResponse?.total_store_member_coupons_count || 0;
        }
    },
    mutations: {
        setStoreCouponsResponse(state, payload) {
            state.storeCouponsResponse = payload;
        },
        setStoreCouponsPage(state, payload) {
            state.storeCouponsPage = payload;
        },
        setStoreCouponInfo(state, payload) {
            state.storeCouponInfo = payload;
        },
        setMemberCouponsResponse(state, payload) {
            state.memberCouponsResponse = payload;
        },
        setMemberCouponInfo(state, payload) {
            state.memberCouponInfo = payload;
        }
    },
    actions: {
        async getStoreCoupons({ commit, state }) {
            try {
                const response = (await getStoreCoupons(state.storeCouponsData)).data.data
                console.log(response)
                commit('setStoreCouponsResponse', response);
                commit('setStoreCouponsPage', response.page + 1);
            } catch (error) {
                console.error('getStoreCoupons error', error);
            }
        },
        async getCouponInfo({ commit }, coupon_id) {
            try {
                const data = {
                    coupons_id: coupon_id
                }
                const response = (await getCouponInfo(data)).data.data.coupon_info
                console.log('store coupon info', response)
                commit('setStoreCouponInfo', response);
            } catch (error) {
                console.error('getCouponInfo error', error);
            }
        },
        async getMemberCoupons({ commit, rootGetters }) {
            const data = {
                store_member_uuid: rootGetters['userData/storeMemberUuid']
            }
            const response = (await getMemberCoupons(data)).data.data
            if (response.msg === 'Failed') {
                throw response.err_msg
            }
            console.log('member coupons', response)
            commit('setMemberCouponsResponse', response);
        },
        async getMemberCouponInfo({ commit }, coupon_uuid) {
            try {
                const data = {
                    coupon_uuid: coupon_uuid
                }
                const response = (await getMemberCouponInfo(data)).data.data.coupon_info
                console.log('member coupon info', response)
                commit('setMemberCouponInfo', response);
            } catch (error) {
                console.error('getMemberCouponInfo error', error);
            }
        },
        async claimCoupon({ dispatch }, coupon_id) {
            try {
                const data = {
                    coupons_id: coupon_id
                }
                const res = await claimCoupon(data)
                console.log('claim coupon res', res)
                dispatch('getMemberCoupons')
            } catch (error) {
                console.error('claimCoupon error', error);
            }
        }
    }
}